/**
 * @file 問い合わせ種別変更
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ChangeInquiryType
 * @classdesc 問い合わせ種別変更
 */
export default class ChangeInquiryType {
	/**
	 * @constructor
	 * @param {jQuery} $e - .inquiry_type
	 */
	constructor($e) {
		console.log('ChangeInquiryType.constructor');
		this._$e = $e;
		this._$itemWrap = $('#item-code-wrap');
		this._$orderWrap = $('#order-id-wrap');
		$e.on('change', () => this.onChange());
		const params = Common.getParam();
		const itemValue = $('option.item').attr('value');
		const orderValue = $('option.order').attr('value');
		if(params['item_code'] && params['item_code'] !== ''){
			$e.val(itemValue);
			$('[name=item_code]').val(params['item_code']);
			this.openItemArea();
		}else if(params['order_code'] && params['order_code'] !== ''){
			$e.val(orderValue);
			$('[name=order_code]').val(params['order_code']);
			this.openOrderArea();
		}
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ChangeInquiryType
	 * @return {undefined}
	 */
	onChange() {
		console.log('ChangeInquiryType.onChange');
		const $selected = this._$e.find('option:selected');
		if($selected.hasClass('item')) {
			this.openItemArea();
		}else if($selected.hasClass('order')){
			this.openOrderArea();
		}else{
			Common.addIgnoreValidate(this._$itemWrap);
			Common.addIgnoreValidate(this._$orderWrap);
		}
	};


	/**
	 * 商品コード入力を開く
	 *
	 * @memberof ChangeInquiryType
	 * @return {undefined}
	 */
	openItemArea() {
		console.log('ChangeInquiryType.openItemInput');
		this._$itemWrap.show().find('.validate').removeClass('ignore-validate');
		Common.addIgnoreValidate(this._$orderWrap);
	}


	/**
	 * 受注番号入力を開く
	 *
	 * @memberof ChangeInquiryType
	 * @return {undefined}
	 */
	openOrderArea() {
		console.log('ChangeInquiryType.openOrderArea');
		this._$orderWrap.show().find('.validate').removeClass('ignore-validate');
		Common.addIgnoreValidate(this._$itemWrap);
	}
}
